export const ONE_DAY_UNIX_VALUE = 86340;
